'use client'

import { useCallback, useEffect, useRef } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'

export function useCmsBallLinkTracker(alt: string) {
  const { publish } = useEventBusContext()
  const ref = useRef<HTMLSpanElement>(null)

  const handleClick = useCallback(() => {
    publish(EventType.BALL_MENU_CLICKED, { click_text: alt })
  }, [alt, publish])

  useEffect(() => {
    const parent = ref.current?.parentElement
    if (!parent) {
      return
    }
    parent.addEventListener('click', handleClick)
    return () => {
      parent.removeEventListener('click', handleClick)
    }
  }, [handleClick])

  return { ref }
}
